import React from 'react'
// Components
import Header from '~2022/components/Header'
import Footer from '~2022/components/Footer'

// eslint-disable-next-line no-unused-vars
const Layout = ({ children, page }) => {
  return (
    <>
      <Header />
      <main itemScope itemProp="mainContentOfPage">
        {children}
      </main>
      <div style={{ paddingBottom: '160px' }}></div>
      <Footer />
    </>
  )
}

export default Layout
